/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Model representing the content and header style for the Titles of pages, sections and lists
 */
export class ContentPageTitleModel { 
    /**
     * Text for the title of the page, section or list
     */
    StringContent?: string;
    /**
     * Header type for the text: H1 = 0, H2 = 1, H3 = 2, H4 = 3, H5 = 4, H6 = 5
     */
    HeaderType?: ContentPageTitleModel.HeaderTypeEnum;
}
export namespace ContentPageTitleModel {
    export type HeaderTypeEnum = 0 | 1 | 2 | 3 | 4 | 5;
    export const HeaderTypeEnum = {
        NUMBER_0: 0 as HeaderTypeEnum,
        NUMBER_1: 1 as HeaderTypeEnum,
        NUMBER_2: 2 as HeaderTypeEnum,
        NUMBER_3: 3 as HeaderTypeEnum,
        NUMBER_4: 4 as HeaderTypeEnum,
        NUMBER_5: 5 as HeaderTypeEnum
    };
}



// WEBPACK FOOTER //
// ./src/app/model/contentPageTitleModel.ts